var React = require('react');

function Caret (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.0455 11.9059L5.63861 7.59099L5 8.25277L10.0686 13.1851L15 8.1386L14.3382 7.5L10.0455 11.9059Z"}));
}

Caret.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = Caret;

Caret.default = Caret;
